import React from 'react';
import {TabMenu} from "../../ui/menu/TabMenu";

interface MagasinMenuInterface {
    currentTab: string,
    setCurrentTab: Function,
}

const MagasinMenu = ({currentTab, setCurrentTab}: MagasinMenuInterface) => {
    const tabs = [
        {type: 'magasin', title: 'Informations', pathname: 'magasin', linkActif: true},
        {type: 'clients', title: 'Mes clients', pathname: 'clients', linkActif: true},
        {type: 'pointages', title: 'Mes pointages', pathname: 'pointages', linkActif: true},
        {type: 'compteurs', title: 'Mes compteurs', pathname: 'compteurs', linkActif: true},
    ];

  return (
      <>
          <TabMenu currentTab={currentTab} tabs={tabs} numberTabsToShow={2} setCurrentTabFunction={setCurrentTab} />
      </>
  );
}

export default MagasinMenu
